"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsEventName = void 0;
exports.instanceOfAnalyticsEventName = instanceOfAnalyticsEventName;
exports.AnalyticsEventNameFromJSON = AnalyticsEventNameFromJSON;
exports.AnalyticsEventNameFromJSONTyped = AnalyticsEventNameFromJSONTyped;
exports.AnalyticsEventNameToJSON = AnalyticsEventNameToJSON;
exports.AnalyticsEventNameToJSONTyped = AnalyticsEventNameToJSONTyped;
/**
 *
 * @export
 */
exports.AnalyticsEventName = {
    ShiftViewedByNurse: 'shift_viewed_by_nurse',
    OrientationOpportunityViewedByFacilityAdmin: 'orientation_opportunity_viewed_by_facility_admin',
    OrientationOpportunityViewedByNurse: 'orientation_opportunity_viewed_by_nurse'
};
function instanceOfAnalyticsEventName(value) {
    for (const key in exports.AnalyticsEventName) {
        if (Object.prototype.hasOwnProperty.call(exports.AnalyticsEventName, key)) {
            if (exports.AnalyticsEventName[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function AnalyticsEventNameFromJSON(json) {
    return AnalyticsEventNameFromJSONTyped(json, false);
}
function AnalyticsEventNameFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function AnalyticsEventNameToJSON(value) {
    return value;
}
function AnalyticsEventNameToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=AnalyticsEventName.js.map